// Fixed filter option order for the View All Notes tab (OR-22848), matching
// the Figma prototype's dropdown sequence. Values are the exact caps2-parity
// strings documented on `WorkbenchViewAllNotesApi.getViewAllNotes` — recap is
// the single source of truth for these, so they are NOT re-cased or relabeled
// client-side (e.g. "DEALER" stays upper-case even though the prototype shows
// "Dealer").
export const VIEW_ALL_NOTES_FILTERS = [
  "CAPS",
  "DEALER",
  "DSC Analyst",
  "Verification",
  "Advance Adjustment",
  "Re-assign",
] as const;

export type ViewAllNotesFilter = (typeof VIEW_ALL_NOTES_FILTERS)[number];

export const ALL_VIEW_ALL_NOTES_FILTER = "All";

export type ViewAllNotesFilterOption = ViewAllNotesFilter | typeof ALL_VIEW_ALL_NOTES_FILTER;

export const DEFAULT_VIEW_ALL_NOTES_FILTER = ALL_VIEW_ALL_NOTES_FILTER;

// i18n key suffix for each filter's display label (audit.viewAllNotes.filters.*).
// Kept separate from the filter value itself so the value sent to the BFF
// stays the exact caps2-parity string while the rendered label goes through
// `t()`. Typed as a literal union (not `string`) so `t(`…filters.${key}`)`
// resolves against the real translation-key union instead of widening to
// `string` and losing type-checking against `en.json`.
export const VIEW_ALL_NOTES_FILTER_LABEL_KEYS: Record<
  ViewAllNotesFilterOption,
  "all" | "caps" | "dealer" | "dscAnalyst" | "verification" | "advanceAdjustment" | "reassign"
> = {
  All: "all",
  CAPS: "caps",
  DEALER: "dealer",
  "DSC Analyst": "dscAnalyst",
  Verification: "verification",
  "Advance Adjustment": "advanceAdjustment",
  "Re-assign": "reassign",
};
